import { useEffect, useState } from 'react'

import { api } from './api'

// /health/db and /health/api require authentication (unlike /health/readiness, which is
// anonymous for external monitors) - must go through the shared api client so the MSAL bearer
// token is attached, or every check 401s regardless of actual system health.
export function useHealthStatus() {
  const [dbHealthy, setDbHealthy] = useState<boolean | null>(null)
  const [apiHealthy, setApiHealthy] = useState<boolean | null>(null)
  const [checkedAt, setCheckedAt] = useState<Date | null>(null)

  useEffect(() => {
    async function fetchHealth() {
      try {
        await api.get('/health/db')
        setDbHealthy(true)
      } catch {
        setDbHealthy(false)
      }
      try {
        await api.get('/health/api')
        setApiHealthy(true)
      } catch {
        setApiHealthy(false)
      }
      setCheckedAt(new Date())
    }
    fetchHealth()
    const interval = setInterval(fetchHealth, 10000)
    return () => clearInterval(interval)
  }, [])

  return { dbHealthy, apiHealthy, checkedAt }
}
